const Subscription = () => {
    
  return (
    <div className="Subscription">
      Vous êtes inscrits aux cours suivants:
    </div>
  );
};
    
export default Subscription;